module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CouponView.js"));
	}, "CouponView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponView!./src/pages/Shop/Member/Wallet/Coupon/CouponView.js
// module id = 1071
// module chunks = 438